import React from "react";
import "./css/footer.css";

const Footer = () => {
  return (
    <div id="footer">
      <div className="footerrmain">
        <div>
          <h1 className="footerhead">Get In Touch</h1>
          <div className="designfooter"></div>
        </div>
        <h1 className="footermyname">Bharat Rozodkar</h1>
        <div className="footercontact">
          <div className="footerchild">
            <a
              target="_blank"
              href="https://www.linkedin.com/in/bharat-rozodkar-76a5a8236/"
              rel="noreferrer"
            >
              <img src="./linkedin.png" alt="" className="img" />
            </a>
            <p>LinkedIn</p>
          </div>
          <div className="footerchild">
            <a
              href="mailto:rozodkarbharat@gmail.com"
              target="_blank"
              rel="noreferrer"
            >
              <img className="round-image" src="email.png" alt="" />
            </a>
            <p>Email</p>
          </div>
          <div className="footerchild">
            <a
              href="https://github.com/rozodkarbharat"
              target="_blank"
              rel="noreferrer"
            >
              <img className="round-image" src="./github.png" alt="" />
            </a>
            <p>GitHub</p>
          </div>
          <div className="footerchild">
            <a href="tel:9096005866">
              <img className="round-image" src="phone.png" alt="" />
            </a>
            <p>Phone : 9096005866</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
